//import logo from './logo.svg';
import "./App.css";
import Navbar from "./components/layout/Navbar";
import HeroSection from "./components/sections/HeroSection";
import AboutSection from "./components/sections/AboutSection";
import EquipmentSection from "./components/sections/EquipmentSection";
import ServicesSection from "./components/sections/ServicesSection";
import TestimonialsSection from "./components/sections/TestimonialsSection";
import MelodyBandSection from "./components/sections/MelodyBandSection";
import TeamSection from "./components/sections/TeamSection";
import ContactSection from "./components/sections/ContactSection";
import Footer from "./components/layout/Footer";

function App() {
  return (
    <div className="App">
      <a href="#home" className="floating-logo" aria-label="Go to home section">
        <img src="/logo.png" alt="Abbott Music Studio" />
      </a>
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <EquipmentSection />
        <ServicesSection />
        <TestimonialsSection />
        <MelodyBandSection />
        <TeamSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
